import * as yup from "yup";
import FormConstants from "./Form.constants";

export const outageSchema = yup.object().shape({
  outageFormName: yup
    .string()
    .min(6, FormConstants.FeedbackMessages.nameMin)
    .max(20, FormConstants.FeedbackMessages.nameMax)
    .matches(FormConstants.nameRegExp, FormConstants.FeedbackMessages.nameMatch)
    .required(FormConstants.FeedbackMessages.nameRequired),
  outageFormPhone: yup
    .string()
    .max(12, FormConstants.FeedbackMessages.phoneMax)
    .matches(
      FormConstants.phoneRegExp,
      FormConstants.FeedbackMessages.phoneMatch
    )
    .required(FormConstants.FeedbackMessages.phoneRequired),
  outageFormEmail: yup
    .string()
    .email(FormConstants.FeedbackMessages.emailMatch)
    .max(60, FormConstants.FeedbackMessages.emailMax)
    .required(FormConstants.FeedbackMessages.emailRequired),
  outageFormComments: yup
    .string()
    .min(1)
    .max(190, FormConstants.FeedbackMessages.additionalDetailsMax)
    .matches(
      FormConstants.commentsRegExp,
      FormConstants.FeedbackMessages.emojisRestricted
    ),
  outageFormDropdown: yup
    .string()
    .required(FormConstants.FeedbackMessages.dropdownOptionRequired),
});

export const pinModeSchema = yup.object().shape({
  outageFormName: yup
    .string()
    .min(6, FormConstants.FeedbackMessages.nameMin)
    .max(20, FormConstants.FeedbackMessages.nameMax)
    .matches(FormConstants.nameRegExp, FormConstants.FeedbackMessages.nameMatch)
    .required(FormConstants.FeedbackMessages.nameRequired),
  outageFormPhone: yup
    .string()
    .max(12, FormConstants.FeedbackMessages.phoneMax)
    .matches(
      FormConstants.phoneRegExp,
      FormConstants.FeedbackMessages.phoneMatch
    )
    .required(FormConstants.FeedbackMessages.phoneRequired),
  outageFormEmail: yup
    .string()
    .email(FormConstants.FeedbackMessages.emailMatch)
    .max(60, FormConstants.FeedbackMessages.emailMax)
    .required(FormConstants.FeedbackMessages.emailRequired),
  outageFormComments: yup
    .string()
    .min(1)
    .max(190, FormConstants.FeedbackMessages.additionalDetailsMax)
    .matches(
      FormConstants.commentsRegExp,
      FormConstants.FeedbackMessages.emojisRestricted
    ),
  outageFormDropdown: yup
    .string()
    .required(FormConstants.FeedbackMessages.dropdownOptionRequired),
  outageFormBracketType: yup
    .string()
    .required(FormConstants.FeedbackMessages.bracketTypeRequired),
});

export const searchSchema = yup.object().shape({
  searchFormText: yup
    .string()
    .max(100)
    .required(FormConstants.FeedbackMessages.searchTextRequired),
});

export const acceptOutageSchema = yup.object().shape({
  acceptOutageFormGISID: yup
    .number()
    .required(FormConstants.FeedbackMessages.adminGisIdRequired),
});

const getBlobFromDataURI = (dataURI: string): Blob => {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeType = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeType });
};

const getDataUriFromBlob = (blob: Blob | Blob[], callback: any): void => {
  const fr = new FileReader();
  fr.onload = function (e: ProgressEvent<FileReader>) {
    callback(e.target?.result);
  };

  fr.readAsDataURL(blob as Blob);
};

const getBlobSizeInMB = (blob: Blob): number => {
  return blob.size / 1024 / 1024;
};

export default {
  outageSchema,
  pinModeSchema,
  searchSchema,
  acceptOutageSchema,
  getBlobFromDataURI,
  getDataUriFromBlob,
  getBlobSizeInMB,
};
